import { render, staticRenderFns } from "./Namirnice.vue?vue&type=template&id=89158ac0&scoped=true"
import script from "./Namirnice.vue?vue&type=script&lang=js"
export * from "./Namirnice.vue?vue&type=script&lang=js"
import style0 from "./Namirnice.vue?vue&type=style&index=0&id=89158ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89158ac0",
  null
  
)

export default component.exports